// Moving focus after a MUI Modal or Drawer closes.
//
// MUI strips the aria-hidden it puts on the rest of the page in the Modal's own
// onExited handler - that is, only once the exit transition has finished, measured
// at ~195ms for a Drawer. A plain setTimeout(..., 50) therefore lands focus at
// ~60ms, while the target is still inside an aria-hidden="true" subtree, where
// assistive technology announces nothing at all: the field name, the error the
// field points aria-describedby at, and the button label all go unread. That
// defeats the entire point of moving focus.
//
// So keep the 50ms cadence the drawers already used, but retry on it until the
// target is exposed, and give up rather than loop forever if something else is
// keeping it hidden. Where no modal is involved nothing is hidden and this focuses
// on the first tick, exactly as the bare setTimeout did.
const FOCUS_DELAY_MS = 50;
const MAX_ATTEMPTS = 10;

export const focusWhenExposed = (getTarget, attempt = 0) => {
    setTimeout(() => {
        const el = getTarget();
        if (!el) return;
        if (el.closest?.('[aria-hidden="true"]') && attempt < MAX_ATTEMPTS) {
            focusWhenExposed(getTarget, attempt + 1);
            return;
        }
        el.focus();
    }, FOCUS_DELAY_MS);
}
